
import React , { useState , useContext } from "react";
import { Link , NavLink, Outlet , useNavigate } from "react-router-dom";
import  { WebAssetsContext }  from "../../App";
import Swal from 'sweetalert2';
import { ToastContainer, toast , Zoom } from 'react-toastify';

const  Addwallet = (props) => {
    //console.log(props.user)
   // console.log(props.show)
    const WebAssets = useContext(WebAssetsContext);
    const api = WebAssets.apiURL;
    const navigate = useNavigate();
    const [disabled, setDisabled] = useState(false);
    const [txn, setTxn] = useState("");
    const [amount, setAmount] = useState("");

    const errortoast = (text) => 
    {
      toast.error(text ,
         {
            autoClose: 3000,
            transition:Zoom,
            theme: "colored",
            closeOnClick: true,
            pauseOnHover: true,
          }
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisabled(true);
        try {
          let res = await fetch(api+"addWallet", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              user_id: props.user.id,
              txn:txn,
              amount: amount,
            }),
          });
          let output = await res.json();
          setDisabled(false);
          if (res.status === 200) {
            if(output.status === 2)
              {
                getvalidationErr(output.response);
              }
            if(output.status === true)
              {
                setTxn('');
                setAmount('');
                setDisabled(false);
                Swal.fire({  
                  title: 'Success',  
                  text: 'Wallet amount added successfully!',
                  icon: 'success'
                }).then((result) => {
                  if (result.isConfirmed) {
                    props.hideModal()
                    props.fetchData()
                   
                  } 
                });
              }
    
            }
        } catch (err) {
          setDisabled(false);
        }
      };

    const getvalidationErr = (errors) =>
    {
        const errorsConvertInArry = Object.values(errors);
        let collectAllValidationErr = [];
        errorsConvertInArry.forEach((error, index) => {
        collectAllValidationErr.push(<div key={index}>{error}</div>);
        });
        const storeAllValidtionErr = (
        <>
        {collectAllValidationErr}
        </>
        );
        errortoast(storeAllValidtionErr);
    }


    return (
    <> 
     <ToastContainer />
    {props.show == true ? 
        <div className={'modal-container modalshow'}>
                <div className="custom-modal-content">
                    <div className="custom-modal-header">
                        <h1 className="header-title-custom-modal">Add Wallet ({props.user.name})</h1>
                        
                    </div>
                    
                        <span className="closeModal fa fa-times" onClick={ () => props.hideModal() }></span>
                   
                    <div>

                    </div>
                    <form onSubmit={handleSubmit} id="create-course-form">
                    <div className="custom-modal-body">
                        
                        <div className="row">
                            <div className="col-sm-12"> 
                                <div className="form-group">
                                    <label>Transaction ID <small className="text-danger">*</small></label>
                                    <input
                                        type="text"
                                        value={txn}
                                        placeholder="Transaction ID"
                                        onChange={(e) => setTxn(e.target.value)}
                                        className="form-control"
                                        />
                                    </div>
                            </div>

                            <div className="col-sm-12"> 
                                <div className="form-group">
                                    <label>Wallet Amount <small className="text-danger">*</small></label>
                                    <input
                                        type="text"
                                        value={amount}
                                        placeholder="Wallet Amount"
                                        onChange={(e) => setAmount(e.target.value)}
                                        className="form-control"
                                        />
                                    </div>
                            </div>

                        </div>
                    </div>
                    <div className="custom-modal-footer text-center">
                            <button className="btn btn-primary mr-1"  type="submit" disabled={disabled}> {disabled == false ? 'Add Wallet': 'Processing...'} </button>
                    </div>
                    </form>
                </div>
        </div>
       : '' }
       
    </>

  );
}

export default Addwallet;
